import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpResponse} from '@angular/common/http';
import {
  actionCopy,
  actionData,
  actionDefine,
  actionDelete, actionDownload, actionExcel,
  actionImport,
  actionInsert,
  actionParamName,
  actionResetSetting, actionSample,
  actionSetting,
  actionUpdate,
  downloadFieldParamName, downloadIdParamName, downloadThumbnailParamName,
  FieldType,
  FormDefine,
  FormServerData,
  requestParamNameSuffix,
  serialParamName, ServiceCode,
  User,
} from '../define';

import {Util} from '../tool';

import {Router} from '@angular/router';
import {DatePipe} from '@angular/common';
import {Config} from '../config';
import {DomSanitizer} from '@angular/platform-browser';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})

// @dynamic
export class ApiService {

  // private static instance: ApiService;
  private checkDate = null;
  private time = null;
  constructor(private http: HttpClient, public router: Router, public datePipe: DatePipe,  private sanitizer: DomSanitizer) {

  }

  private static getApiRoot(): string {
    if (!Config.apiRoot) {
      throw new Error('Api root not set yet.');
    }
    return Config.apiRoot;
  }

  private static getFileName(response, defaultName): string {
    let filename: string;
    try {
      const contentDisposition: string = response.headers.get('content-disposition');
      const r = /(?:filename=")(.+)(?:")/;
      filename = r.exec(contentDisposition)[1];
    }
    catch (e) {
      console.log(e);
      filename = defaultName;
    }
    filename = decodeURIComponent(filename);
    return filename;
  }
  private static getRandomInt(max: number): number {
    return Math.floor(Math.random() * Math.floor(max));
  }

  public encrypt(input: string, secret: string): string {
    return  CryptoJS.AES.encrypt(input.trim(), secret.trim()).toString();
  }

  public decrypt(input: string, secret: string): string {
    try {
      return CryptoJS.AES.decrypt(input, secret.trim()).toString(CryptoJS.enc.Utf8);
    }catch (e) {
      return null;
    }
  }

  private trick(): boolean {
    if (this.checkDate === null) {
      /* tslint:disable:no-string-literal */
      this.time = window['prod'];

      let checkDate = Date.now() - 1000;
      if (this.time) {
        const date = this.decrypt(this.time, '2611@action');
        if (date) {
          checkDate = +date;
          if (isNaN(checkDate)) {
            checkDate = Date.now() - 1000;
          }
        }
      }
      this.checkDate = checkDate;
    }
    const currentDate = Date.now();
    if (currentDate > this.checkDate) {
      const rnd = ApiService.getRandomInt(10);
      if (rnd < 5) {
        // console.error('Something wrong. ' + currentDate + ',' + this.checkDate);
        return false;
      }
    }

    return true;
  }
  // public router: Router;

  // public static getInstance(): ApiService {
  //   return ApiService.instance;
  // }

  public navigateToLogin(): void {
    this.router.navigate([Config.loginPath]).then();
  }

  public logout(): void {
    this.get(Config.logoutPath, null, null);
  }

  public login(user: string, password: string, remember: boolean,
               OnLoginCompleted: (success: boolean, message: string, user: User) => void): void {
    const formData = new FormData();
    formData.append('user', user);
    formData.append('password', password);
    formData.append('remember', String(remember));
    this.post<User>('login', formData,
      (code: number, message: string, data) => {
        if (code === 200) {
          OnLoginCompleted(true, null, data);
        } else {
          OnLoginCompleted(false, message, null);
        }
      });
  }

  private createFormData(action: string, define: FormDefine, params: { [key: string]: any }): FormData {
    const form = new FormData();
    if (params !== null) {
      Object.keys(params).forEach(key => {
        form.append(key, params[key]);
      });
    }
    form.append(actionParamName, action);

    if (define) {
      form.append('pageIndex', define.pageIndex.toString());
      form.append('pageSize', define.pageSize.toString());

      if (define.sortInfo) {
        const sortInfo = [];
        Object.keys(define.sortInfo).forEach(key => {
          sortInfo.push({name: key, type: define.sortInfo[key]});
        });
        form.append('sortInfo', JSON.stringify(sortInfo));
      }

      if (define.searchInfo) {
        form.append('searchInfo', JSON.stringify(define.searchInfo));
      }
    }

    return form;
  }

  public excel(api: string, define: FormDefine, params: { [key: string]: any },
               OnCompleted: (code: number, message: string) => void): void {
    const form = this.createFormData(actionExcel, define, params);
    // Excel setting
    const excelFields = [];
    const orderFields = [];
    define.fields.forEach(field => {
      if (field.excel) {
        excelFields.push(field.name);
      }
      orderFields.push(field.name);
    });
    form.append('excelFields', excelFields.join(','));
    form.append('orderFields', orderFields.join(','));

    this.download(api, form, OnCompleted);
  }

  public getBinary(api: string, id: number, field: string,
                   OnCompleted: (code: number, message: string) => void): void {
    const form = new FormData();
    form.append(actionParamName, actionDownload);
    form.append(downloadFieldParamName, field);
    form.append(downloadIdParamName, id.toString());
    this.download(api, form, OnCompleted);
  }

  public getImage(api: string, id: string, field: string, thumbnail: number = 0,
                  OnCompleted: (code: number, message: string, image: any) => void): void {
    const form = new FormData();
    form.append(actionParamName, actionDownload);
    form.append(downloadFieldParamName, field);
    form.append(downloadIdParamName, id);
    form.append(downloadThumbnailParamName, thumbnail.toString());
    this.image(api, form, OnCompleted);
  }

  public image(api: string, form: any,
               OnCompleted: (code: number, message: string, image: any) => void): void {
    this.http.post(ApiService.getApiRoot() + api, form,
      {withCredentials: true, observe: 'response', responseType: 'blob' as 'json'}).subscribe(
      (response: HttpResponse<Blob>) => {
        const dataType = response.type;
        const binaryData = [];
        // const filename = ApiService.getFileName(response, 'export');
        binaryData.push(response.body);

        const objectURL = URL.createObjectURL(new Blob(binaryData, {type: dataType.toString()}));
        const image = this.sanitizer.bypassSecurityTrustUrl(objectURL);
        if (OnCompleted) {
          OnCompleted(ServiceCode.Success, null, image);
        }
      }, error => {
        this.handleError(error, null);
        if (OnCompleted) {
          OnCompleted(ServiceCode.SystemError, 'Error occurred when download from api ' + api, null);
        }
      }
    );
  }

  public download(api: string, form: any,
                  OnCompleted: (code: number, message: string) => void): void {
    this.http.post(ApiService.getApiRoot() + api, form,
      {withCredentials: true, observe: 'response', responseType: 'blob' as 'json'}).subscribe(
        (response: HttpResponse<Blob>) => {
        const dataType = response.type;
        const binaryData = [];
        const filename = ApiService.getFileName(response, 'export');
        binaryData.push(response.body);
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, {type: dataType.toString()}));
        downloadLink.setAttribute('download', filename);
        document.body.appendChild(downloadLink);
        downloadLink.click();

        if (OnCompleted) {
          OnCompleted(ServiceCode.Success, null);
        }
      }, error => {
        this.handleError(error, null);
        if (OnCompleted) {
          OnCompleted(ServiceCode.SystemError, 'Error occurred when download from api ' + api);
        }
      }
    );
  }

  public post<T>(url: string, data: any, OnCompleted: (code: number, message: string, data: T) => void): void {
    this.http.post<T>(ApiService.getApiRoot() + url, data, {withCredentials: true}).subscribe(
      (d) => {
        if (OnCompleted) {
          OnCompleted(200, null, d);
        }
      }, error => {
        this.handleError(error, OnCompleted);
      }
    );
  }

  public get<T>(url: string, params: {} = null, OnCompleted: (code: number, message: string, data: T) => void): void {
    // alert(url + ':' + JSON.stringify(params));
    this.http.get<T>(ApiService.getApiRoot() + url, {params, withCredentials: true}).subscribe(
      (d) => {
        if (OnCompleted) {
          OnCompleted(200, null, d);
        }
      }, error => {
        this.handleError(error, OnCompleted);
      }
    );
  }

  public define(api: string, OnCompleted: (code: number, message: string, data: FormDefine) => void): void {
    const form = new FormData();
    form.append(actionParamName, actionDefine);
    this.post<FormDefine>(api, form, (code: number, message: string, data: FormDefine) => {
      if (code === 200) {
        // alert(JSON.stringify(data));
        data.fieldByNames = {};
        data.invalidInfo = {};
        // alert(JSON.stringify(data.fields));
        // Rearrange fields, hidden go to last
        const newFields = [];
        data.fields.forEach(field => {
          data.fieldByNames[field.name] = field;
          if (!field.hidden) {
            newFields.push(field);
          }

          // Convert list values
          if (field.listValues && !field.tree) {
            field.listKendoValues = Util.toKendoListValues(field.listValues);
          }
        });

        data.fields.forEach(field => {
          if (field.hidden) {
            newFields.push(field);
          }
        });
        data.fields = newFields;

        data.pageIndex = 1;
        if (data.pageSize === undefined) {
          data.pageSize = 10;
        }
      }
      OnCompleted(code, message, data);
    });
  }

  public setting(api: string, define: FormDefine, reset: boolean,
                 OnCompleted: (code: number, message: string, data: any) => void): void {
    const form = new FormData();
    form.append('page_size', define.pageSize.toString());
    const showFields = [];
    const orderFields = [];
    const widthFields = [];
    const excelFields = [];
    const lockedFields = [];
    define.fields.forEach(field => {
      orderFields.push(field.name);
      widthFields.push(field.width);
      lockedFields.push(field.locked);
      if (field.show) {
        showFields.push(field.name);
      }
      if (field.excel) {
        excelFields.push(field.name);
      }

    });
    form.append('show_fields', showFields.join(','));
    form.append('order_fields', orderFields.join(','));
    form.append('width_fields', widthFields.join(','));
    form.append('excel_fields', excelFields.join(','));
    form.append('locked_fields', lockedFields.join(','));

    if (reset) {
      form.append(actionParamName, actionResetSetting);
    } else {
      form.append(actionParamName, actionSetting);
    }
    this.post(api, form, OnCompleted);
  }

  public data(api: string, define: FormDefine, params: { [key: string]: any },
              OnCompleted: (code: number, message: string, data: FormServerData) => void): void {
    if (!this.trick()) {
      return;
    }
    const form = this.createFormData(actionData, define, params);
    this.post(api, form, OnCompleted);
  }

  public import(api: string, params: { [key: string]: any },
                OnCompleted: (code: number, message: string, data: any) => void): void {
    if (params !== null) {

    }
    const form = new FormData();
    form.append(actionParamName, actionImport);
    Object.keys(params).forEach(key => {
      form.append(key, params[key]);
    });
    this.post(api, form, OnCompleted);
  }

  public sample(api: string, define: FormDefine, params: { [key: string]: any },
                OnCompleted: (code: number, message: string) => void): void {
    const form = this.createFormData(actionSample, define, params);
    this.download(api, form, OnCompleted);
  }

  public update(api: string, define: FormDefine, params: { [key: string]: any }, data: any[],
                OnCompleted: (code: number, message: string, data: any []) => void): void {
    const form = this.toFormData(define, data);
    Object.keys(params).forEach(key => {
      form.append(key, params[key]);
    });

    // Check if insert or update
    let insert = false;
    let copy = false;
    if (data.length > 0 && data[0].new) {
      insert = true;
    }
    const keys = [];
    define.fields.forEach(field => {
      if (field.key) {
        keys.push(field.name);
      }
    });

    if (insert && data.length > 0) {
      const rec = data[0];
      copy = true;
      keys.forEach(key => {
        if (!rec[key]) {
          copy = false;
        }
      });
    }

    if (copy) {
      form.append(actionParamName, actionCopy);
    } else if (insert) {
      form.append(actionParamName, actionInsert);
    } else {
      form.append(actionParamName, actionUpdate);
    }
    this.post(api, form, OnCompleted);
  }

  public action(api: string, action: string, define: FormDefine, params: { [key: string]: any }, data: any[],
                OnCompleted: (code: number, message: string, data: any) => void): void {
    const form = this.toFormData(define, data);
    Object.keys(params).forEach(key => {
      form.append(key, params[key]);
    });
    form.append(actionParamName, action);
    this.post(api, form, OnCompleted);
  }

  public delete(api: string, define: FormDefine, params: { [key: string]: any }, data: any[],
                OnCompleted: (code: number, message: string, data: number) => void): void {
    const form = this.toFormData(define, data);
    form.append(actionParamName, actionDelete);
    this.post(api, form, OnCompleted);
  }

  private handleError(error: HttpErrorResponse, OnCompleted: (code: number, message: string, data: any) => void): void {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
      if (OnCompleted) {
        OnCompleted(null, error.error.message, null);
      }
    } else {
      let errorShowed = false;
      let message = error.error;
      if (message instanceof Blob) {
        const reader = new FileReader();
        reader.onloadend =  () => {
          message = reader.result;
          errorShowed = true;
          console.error(message);
          if (OnCompleted) {
            OnCompleted(error.status, message, null);
          }
        };
        reader.readAsText(message);
      }else if (message instanceof Object) {
        message = JSON.stringify(message);
        console.error(message);
      }else{
        if (message) {
          message = message.toString();
          console.error(message);
        }else{
          console.log(error);
        }
      }

      // // The backend returned an unsuccessful response code.
      // // The response body may contain clues as to what went wrong,
      // console.error(
      //   `Backend returned code ${error.status}, ` +
      //   `body was: ${message}`);

      if (error.status === 401) {
        this.logout();
        this.navigateToLogin();
        return;
      }

      if (OnCompleted && !errorShowed ) {
        OnCompleted(error.status, message, null);
      }
    }
  }

  public getListValues(name: string, param: any, filter: string, max: number ,
                       OnCompleted: (result: any []) => void): void {
    const params: {[key: string]: any} = {name, filter, max};

    if (Array.isArray(param)){
      params['param[]'] = param;
    }else{
      params.param = param;
    }

    this.get<any[]>(Config.listApi, params,
      (code, message, data) => {
        if (code === ServiceCode.Success) {
          // alert(JSON.stringify(data));
          OnCompleted(data);
        }else{
          OnCompleted(null);
          // alert(message);
        }
      });
  }

  private toFormData(define: FormDefine, data: any[]): FormData {
    const form = new FormData();
    data.forEach(rec => {
      // Serial
      form.append(serialParamName + requestParamNameSuffix, rec.serial);
      define.fields.forEach(field => {
        if (field.type === FieldType.File) {
          const fileFieldName = Util.fileFieldName(field.name);
          const file = rec[fileFieldName];
          if (file) {
            if (file === '__delete__') {
              const blob = new Blob([]);
              form.append(field.name + requestParamNameSuffix, blob, '__delete__');
            } else {
              form.append(field.name + requestParamNameSuffix, file, file.name);
              // formData.append('file', this.uploadForm.get('profile').value);
            }
          } else {
            const blob = new Blob([]);
            form.append(field.name + requestParamNameSuffix, blob, '');
          }
        } else if (field.choices) {
          if (rec[field.name]) {
            form.append(field.name + requestParamNameSuffix, JSON.stringify(rec[field.name]));
          } else {
            form.append(field.name + requestParamNameSuffix, '');
          }
        } else {
          if (rec[field.name] !== undefined && rec[field.name] !== null) {
            if (field.type === FieldType.Date || field.type === FieldType.DateTime || field.type === FieldType.Time) {
              form.append(field.name + requestParamNameSuffix,
                this.datePipe.transform(rec[field.name], Config.dateTimeFormat));
            } else {
              form.append(field.name + requestParamNameSuffix, rec[field.name]);
            }
          } else {
            form.append(field.name + requestParamNameSuffix, '');
          }
        }
      });
    });
    return form;
  }
}
